import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
    inverted?: boolean
}

// Monogramme : un écrou hexagonal frappé d'un K, jambe basse en orange signal.
export const BrandMark: FC<BrandMarkProps> = ({ className, inverted = false }): ReactNode => {
    const id = useId().replace(/[^a-zA-Z0-9_-]/g, '')
    const nut = inverted ? 'fill-chalk stroke-chalk' : 'fill-ink stroke-ink'
    const letter = inverted ? 'ink' : 'chalk'

    return (
        <svg
            viewBox='0 0 48 48'
            aria-hidden='true'
            focusable='false'
            className={cn('size-9 shrink-0', className)}
        >
            <defs>
                <clipPath id={`${id}-arm`}>
                    <rect x='16' y='13' width='30' height='22' />
                </clipPath>
                <clipPath id={`${id}-leg`}>
                    <rect x='0' y='13' width='48' height='22' />
                </clipPath>
            </defs>

            <polygon
                points='24,2 43.05,13 43.05,35 24,46 4.95,35 4.95,13'
                className={nut}
                strokeWidth='3'
                strokeLinejoin='round'
            />
            <line x1='20.5' y1='22' x2='34.5' y2='39' className='stroke-primary' strokeWidth='5.6' clipPath={`url(#${id}-leg)`} />
            <line x1='14.5' y1='30' x2='34.5' y2='9' className={letter === 'ink' ? 'stroke-ink' : 'stroke-chalk'} strokeWidth='5.6' clipPath={`url(#${id}-arm)`} />
            <rect x='13.5' y='13' width='5' height='22' className={letter === 'ink' ? 'fill-ink' : 'fill-chalk'} />
        </svg>
    )
}

interface BrandLockupProps {
    className?: string
    subline?: boolean
    compact?: boolean
    inverted?: boolean
}

export const BrandLockup: FC<BrandLockupProps> = ({ className, subline = true, compact = false, inverted = false }): ReactNode => {
    return (
        <span className={cn('flex min-w-0 items-center gap-2.5', className)}>
            <BrandMark inverted={inverted} className={compact ? 'size-8' : 'size-9'} />

            <span className={cn('flex min-w-0 flex-col', compact && 'max-[389px]:sr-only')}>
                <span className='heading text-base leading-none tracking-[-0.01em] sm:text-lg'>
                    Kermarec
                </span>

                {subline && (
                    <span className='label-mono mt-1 hidden text-[0.625rem] text-muted-foreground lg:block'>
                        Garage · Nantes · depuis 2011
                    </span>
                )}
            </span>
        </span>
    )
}
